import { Divider, InputNumber } from 'antd'
import { useEffect, useState } from 'react'
import { FormattedHTMLMessage, FormattedMessage, useIntl } from 'react-intl'
import { useParams } from 'react-router-dom'
import ProgressGuideView from '../../../components/ProgressGuideView'
import UploadSticker from '../../../components/upload/UploadSticker'
import { usePackageInfo } from '../../../hooks/reactQuery/usePackage'
import { useUserWithRedirect } from '../../../hooks/user/useUserWithRedirect'

import { makeDefaultPackageInfo } from '../../../utils/makeDefaultPackageInfo'

const defaultPackageInfo = makeDefaultPackageInfo({})

export default function UploadStickerWrapper() {
  const { packageId } = useParams<{ packageId: string }>()
  const user = useUserWithRedirect()
  const {
    data: packageAndSticker,
    error,
    isLoading,
  } = usePackageInfo(packageId, user?.sessionToken)
  const packageInfo = packageAndSticker ? packageAndSticker : defaultPackageInfo

  const [wantedStickerNum, setWantedStickerNum] = useState(24)

  const intl = useIntl()
  return (
    <div>
      <ProgressGuideView
        step="sticker-upload"
        language={intl.locale}
        packType={packageInfo.packType}
      />
      <div className="sticker-upload-pack-box">
        <Divider style={{ margin: 0, background: '#E8E8E8' }} />
        <div className="sticker-upload-pack-info-box">
          <div className="sticker-upload-pack-label">
            <div className="sticker-upload-pack-label-text">
              <FormattedMessage
                id="Upload.packType"
                defaultMessage="Pack Type"
              />
            </div>
          </div>
          <div className="sticker-upload-pack-input">
            <div className="sticker-upload-pack-label-text">
              {packageInfo.packType ? (
                <div className={`pack-type-badge-${packageInfo.packType}`}>
                  <span>
                    <FormattedMessage
                      id={`Upload.packType.${packageInfo.packType}`}
                      defaultMessage="Plus Pack"
                    />
                  </span>
                </div>
              ) : (
                <FormattedMessage
                  id={'Upload.PkgCreation.createPack.packType.undefined'}
                  defaultMessage="No type"
                />
              )}
              {packageInfo.movingStatus && (
                <FormattedMessage
                  id={`Upload.movingStatus.${packageInfo.movingStatus}`}
                  defaultMessage=" "
                />
              )}
            </div>
          </div>
        </div>
        <Divider style={{ margin: 0, background: '#E8E8E8' }} />
        <div className="sticker-upload-pack-info-box">
          <div className="sticker-upload-pack-label">
            <div className="sticker-upload-pack-label-text">
              <FormattedMessage
                id="StickerUpload.stickerCount"
                defaultMessage="Number of stickers"
              />
            </div>
          </div>
          <div className="sticker-upload-pack-input">
            <div className="sticker-upload-pack-label-text">
              <InputNumber
                min={
                  packageInfo.packType === 'PLUS'
                    ? 24
                    : packageInfo.emoticons
                    ? packageInfo.emoticons.length
                    : 1
                }
                max={
                  packageInfo.packType === 'BASIC'
                    ? 23
                    : Number.POSITIVE_INFINITY
                }
                value={wantedStickerNum}
                // disabled={pkgStatus === 'editing' && packType !== 'PLUS'}
                onChange={(num) => {
                  num && setWantedStickerNum(num)
                }}
                style={{ marginRight: '16px' }}
              />
              {packageInfo.packType && (
                <FormattedHTMLMessage
                  id={`StickerUpload.stickerCount.desc.${packageInfo.packType}`}
                  defaultMessage="*24 stickers and above"
                />
              )}
            </div>
          </div>
        </div>
        <Divider style={{ margin: 0, background: '#E8E8E8' }} />
      </div>
      {packageAndSticker && (
        <UploadSticker
          packageAndSticker={packageAndSticker}
          wantedStickerNum={wantedStickerNum}
        />
      )}
    </div>
  )
}
